module.exports = __webpack_public_path__ + "media/images/flags/ua-dff2328608ae1733400ad58fef052247.svg";